import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const ChatComponent = ({ serviceId }) => {
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchMessages();
    const interval = setInterval(fetchMessages, 5000); // Poll every 5s
    return () => clearInterval(interval);
  }, [serviceId]);

  const fetchMessages = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}oosh/service/chat/${serviceId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setMessages(res.data);
    } catch (err) {
      toast.error('Failed to load messages');
      console.error(err);
    }
    setLoading(false);
  };

  const sendMessage = async () => {
    if (!message.trim()) return;
    try {
      await axios.post(`/oosh/chat/${serviceId}`, { message }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setMessage('');
      fetchMessages();
    } catch (err) {
      toast.error('Failed to send message');
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white shadow-md rounded-lg">
      <h2 className="text-2xl font-bold mb-4 text-blue-600">Chat</h2>
      <div className="h-64 overflow-y-auto border p-2 mb-4 rounded">
        {loading && <p className="text-gray-500 text-center">Loading...</p>}
        {messages.map((msg) => (
          <p key={msg._id} className="text-sm mb-2">
            <strong>{msg.senderId.email}:</strong> {msg.message} <span className="text-xs text-gray-500">({new Date(msg.createdAt).toLocaleString()})</span>
          </p>
        ))}
        {!loading && messages.length === 0 && (
          <p className="text-gray-500 text-center">No messages yet</p>
        )}
      </div>
      <div className="flex gap-2">
        <input
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Type your message..."
          className="flex-1 p-2 border rounded-md focus:ring-2 focus:ring-blue-500"
        />
        <button
          onClick={sendMessage}
          className="bg-blue-500 text-white p-2 rounded-md hover:bg-blue-600"
        >
          Send
        </button>
      </div>
    </div>
  );
};

export default ChatComponent;